// https://dracoblue.net/dev/linear-least-squares-in-javascript/
export const findLineByLeastSquares = (values_x, values_y) => {
  let sum_x = 0;
  let sum_y = 0;
  let sum_xy = 0;
  let sum_xx = 0;
  // We'll use those variables for faster read/write access.
  let x = 0;
  let y = 0;
  const values_length = values_x.length;
  const count = values_length;
  if (values_length != values_y.length) {
    throw new Error("The parameters values_x and values_y need to have same size!");
  }
  if (values_length === 0) {
    return [[], []]; // Nothing to do.
  }
  // Calculate the sum for each of the parts necessary.
  for (let v = 0; v < values_length; v++) {
    x = values_x[v];
    y = values_y[v];
    sum_x += x;
    sum_y += y;
    sum_xx += x * x;
    sum_xy += x * y;
  }
  // Calculate m and b for the formular:
  // y = x * m + b
  const m = (count * sum_xy - sum_x * sum_y) / (count * sum_xx - sum_x * sum_x);
  const b = sum_y / count - (m * sum_x) / count;
  // We will make the x and y result line now
  const result_values_x = [];
  const result_values_y = [];
  for (let v = 0; v < values_length; v++) {
    x = values_x[v];
    y = x * m + b;
    result_values_x.push(x);
    result_values_y.push(y);
  }
  return [result_values_x, result_values_y];
};

type SigPadDatum = {
  x: number;
  y: number;
  time: number;
};

type SigPadData = Array<Array<SigPadDatum>>;

export const getHeightOfSignature = (data: SigPadData) => {
  const xVals = data[0].map((datum) => datum.x);
  const yVals = data[0].map((datum) => datum.y);
  const [_, lineY] = findLineByLeastSquares(xVals, yVals);
  let maxHeight = Math.abs(yVals[0] - lineY[0]);
  for (let v = 0; v < lineY.length; v++) {
    if (maxHeight < Math.abs(yVals[v] - lineY[v])) {
      maxHeight = Math.abs(yVals[v] - lineY[v]);
    }
  }
  return maxHeight;
};

export const SIGNATURE_HEIGHT_THRESHOLD = 8.5; // pixels
// 5 is pretty arbitrary, chosen from trying a bunch of different
// valid and invalid signatures
export const MIN_STROKE_LENGTH = 5; // pixels

export const isNotFlat = (data: SigPadData) => getHeightOfSignature(data) >= SIGNATURE_HEIGHT_THRESHOLD;

export const isNotNarrowVertical = (data: SigPadData) => {
  const invertedData = [data[0].map(({ x, y }) => ({ x: y, y: x }))];
  return getHeightOfSignature(invertedData) >= SIGNATURE_HEIGHT_THRESHOLD;
};

export const isNotDot = (data: SigPadData) => data[0].length > 1;

export const validateLongestStrokeLength = (data: SigPadData, minStrokeLength: number = MIN_STROKE_LENGTH) => {
  const strokeLengths = data.map((x) => x.length);
  const longestStroke = Math.max(...strokeLengths);
  return longestStroke > minStrokeLength;
};
